export default defineNuxtPlugin(() => {
  const { initialize } = useIssue474AbTest()
  initialize()
})
